import CycleStat from './CycleStat';
import useCycleData from './useCycleData';

export { useCycleData };
export default CycleStat;
